export const standardTransition = (name, duration = 0.2) => {
  return `${name} ${duration}s linear`;
};
